import type { FilterClause } from 'tio-common/utils/open-search-builder';

const COURSE_APPROVAL_STATES = ['TAS.ApplicationState.PENDING_COURSES_APPROVAL'] as const;
const EVIDENCE_REVIEW_STATES = ['TAS.ApplicationState.PENDING_EVIDENCE_APPROVAL'] as const;
const PROGRAM_APPROVAL_STATES = ['TAS.ProgramInstanceState.PENDING_PROGRAM_APPROVAL'];
const COMPLETION_APPROVAL_STATES = ['TAS.ProgramInstanceState.PENDING_COMPLETION_APPROVAL'];
const WITHDRAWAL_APPROVAL_STATES = ['TAS.ProgramInstanceState.PENDING_WITHDRAWAL_APPROVAL'];

export type PendingStatusType =
  | 'all'
  | 'program'
  | 'courses'
  | 'evidence'
  | 'completion'
  | 'withdrawal';

export function buildApprovalShouldClauses(status: PendingStatusType = 'all'): FilterClause[] {
  const shouldClauses: unknown[] = [];
  const appStates: string[] = [];
  const instanceStates: string[] = [];

  // Collect application states
  if (status === 'all' || status === 'courses') {
    appStates.push(...COURSE_APPROVAL_STATES);
  }

  if (status === 'all' || status === 'evidence') {
    appStates.push(...EVIDENCE_REVIEW_STATES);
  }

  // Collect instance states
  if (status === 'all' || status === 'program') {
    instanceStates.push(...PROGRAM_APPROVAL_STATES);
  }

  if (status === 'all' || status === 'completion') {
    instanceStates.push(...COMPLETION_APPROVAL_STATES);
  }

  if (status === 'all' || status === 'withdrawal') {
    instanceStates.push(...WITHDRAWAL_APPROVAL_STATES);
  }

  // Build optimized clauses - ONE per field instead of multiple
  if (appStates.length > 0) {
    shouldClauses.push({
      terms: {
        tas_application_state_keyword: appStates,
      },
    });
  }

  if (instanceStates.length > 0) {
    shouldClauses.push({
      terms: {
        tas_program_instance_state_keyword: instanceStates,
      },
    });
  }

  return shouldClauses as FilterClause[];
}
